module.exports = {
  "zones": {
    "Africa/Khartoum": ["z", {
      "wallclock": 1509494400000,
      "format": "CAT",
      "abbrev": "CAT",
      "offset": 7200000,
      "posix": 1509483600000,
      "save": 0
    }, {
      "wallclock": 947937600000,
      "format": "EAT",
      "abbrev": "EAT",
      "offset": 10800000,
      "posix": 947930400000,
      "save": 0
    }, {
      "wallclock": -1230768000000,
      "format": "CA%sT",
      "abbrev": "CAT",
      "offset": 7200000,
      "posix": -1230775808000,
      "save": 0,
      "rules": "Sudan"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 7808000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Sudan": [{
      "from": 1970,
      "to": 1985,
      "month": 9,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1972,
      "to": 1985,
      "month": 3,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1971,
      "to": 1971,
      "month": 3,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1970,
      "to": 1970,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }]
  }
};